/* @ngInject */
export default function translations($translateProvider) {
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.useStaticFilesLoader({ prefix: 'assets/i18n/', suffix: '.json' });
    $translateProvider.preferredLanguage('en'); // pick key from localStorage if any
}



// WEBPACK FOOTER //
// ./src/app/config/translations.js